export enum BreakpointsEnum {
  notavailable = -1,
  xs = 0,
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200,
  xxl = 1400
}
